// src/components/layout/Navbar.js
import React, { useState, useEffect, useRef } from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import './Navbar.css';
import { useAuth } from '../../contexts/AuthContext';
// AuthModal supprimé d'ici, il est maintenant dans MainLayout

function Navbar({ theme, toggleTheme, openAuthModal, triggerOnboarding, notifications = [], setNotifications }) {

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // Theme state déplacé dans MainLayout

  const [userMenuOpen, setUserMenuOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(() => (typeof window !== 'undefined' ? window.innerWidth > 1024 : true));
  const userMenuRef = useRef(null);
  const { user: currentUser, logout, isAdmin, isCommercial } = useAuth();
  const location = useLocation();
  const navigate = useNavigate();

  // Auth state déplacé dans MainLayout
  const [hoveredAuth, setHoveredAuth] = useState(null); // 'login' | 'signup' | null
  const [userMenuAnchor, setUserMenuAnchor] = useState('desktop'); // 'desktop' | 'mobile'
  const [notifOpen, setNotifOpen] = useState(false);
  const [notifAnchor, setNotifAnchor] = useState('desktop'); // 'desktop' | 'mobile'
  const [drawerPopupOpen, setDrawerPopupOpen] = useState(false);
  const [drawerPopupType, setDrawerPopupType] = useState('notifications'); // 'notifications' | 'user'

  // Notifications managed by parent (MainLayout)
  const notifMenuRef = useRef(null);
  const mobileNotifMenuRef = useRef(null);
  const mobileUserMenuRef = useRef(null);
  const userInitial = currentUser ? ((currentUser.name || currentUser.email || '?').charAt(0).toUpperCase()) : null;

  const handleActiveStyle = ({ isActive }) => {
    return isActive ? 'active' : '';
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMenuOpen(false);
  };

  useEffect(() => {
    const handleResize = () => {
      const w = window.innerWidth;
      setIsDesktop(w > 1024);
      if (w > 1024 && isMenuOpen) {
        setIsMenuOpen(false);
      }
    };
    if (isMenuOpen) {
      document.body.classList.add('no-scroll');
    } else {
      document.body.classList.remove('no-scroll');
    }
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      document.body.classList.remove('no-scroll');
    };
  }, [isMenuOpen]);

  // L'effet de persistance du thème est maintenant dans MainLayout

  useEffect(() => {
    const onDocClick = (e) => {
      if (userMenuRef.current && !userMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
      if (notifMenuRef.current && !notifMenuRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
      if (mobileNotifMenuRef.current && !mobileNotifMenuRef.current.contains(e.target)) {
        setNotifOpen(false);
      }
      if (mobileUserMenuRef.current && !mobileUserMenuRef.current.contains(e.target)) {
        setUserMenuOpen(false);
      }
    };
    document.addEventListener('click', onDocClick);
    return () => document.removeEventListener('click', onDocClick);
  }, []);

  // L'effet auto-open auth est géré par MainLayout maintenant (ou via openAuthModal passé du parent)
  // Nous l'enlevons d'ici pour éviter les doublons, MainLayout devra le gérer ou nous laissons tel quel
  // MAIS: Navbar ne contrôle plus l'ouverture.
  // Cependant, location.state est accessible ici. 
  // Idéalement MainLayout devrait gérer ça. Pour l'instant je commente ici.
  /*
  useEffect(() => {
    const state = location.state;
    if (!currentUser && (state?.authRequired || state?.adminRequired)) {
      openAuthModal('login');
    }
  }, [location.state, currentUser, openAuthModal]);
  */

  // toggleTheme est passé en props

  // Storage listener pour theme est dans MainLayout

  const toggleUserMenu = (anchor = 'desktop') => {
    if (!currentUser) {
      openAuthModal('login');
      return;
    }
    setUserMenuAnchor(anchor);
    setUserMenuOpen(!userMenuOpen);
  };

  const toggleNotifications = (anchor = 'desktop') => {
    setNotifAnchor(anchor);
    setNotifOpen((prev) => !prev);
  };

  const handleOpenLogin = (e) => {
    if (e && typeof e.preventDefault === 'function') e.preventDefault();
    closeMobileMenu();
    openAuthModal('login');
  };

  const unreadCount = notifications.filter(n => !n.read).length;
  const markAllRead = () => {
    if (!notifications.length) return;
    setNotifications(prev => prev.map(n => ({ ...n, read: true })));
  };

  const openDrawerPopup = (type) => {
    setDrawerPopupType(type);
    setDrawerPopupOpen(true);
  };

  const closeDrawerPopup = () => {
    setDrawerPopupOpen(false);
  };

  return (
    <>
      <nav className={`navbar ${isMenuOpen ? 'menu-is-open' : ''}`} style={{ overflow: 'visible' }}>
        <div className="container navbar-container" style={isDesktop ? { position: 'relative' } : undefined}>
          <div className="navbar-logo">
            <NavLink to="/" onClick={closeMobileMenu}>
              <img src="/images/logoo.png" alt="Logo Info Colab" /> {/* Texte alt fixe */}
            </NavLink>
          </div>

          <div className="navbar-main-content"> {/* Wrapper pour liens et switcher desktop */}
            <ul
              className={`navbar-links ${isMenuOpen ? 'open' : ''}`}
              style={isDesktop ? { flex: 1, justifyContent: 'center', minWidth: 0 } : undefined}
            >
              {!isDesktop && (
                <>
                  <li style={{ marginLeft: 0, padding: '8px 1.5rem 10px' }}>
                    <NavLink
                      to="/"
                      onClick={closeMobileMenu}
                      style={{ display: 'inline-flex', alignItems: 'center', gap: 10, textDecoration: 'none' }}
                    >
                      <img src="/images/logoo.png" alt="Logo Info Colab" style={{ height: 42, width: 'auto', display: 'block' }} />
                    </NavLink>
                  </li>

                  <li style={{ marginLeft: 0, padding: '0 1.5rem 12px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                      <div style={{ fontWeight: 800, fontSize: 14, letterSpacing: 0.3, opacity: 0.9 }}>
                        Menu
                      </div>
                      <div className="mobile-menu-header-actions">
                        <button
                          type="button"
                          className="theme-toggle-btn"
                          onClick={toggleTheme}
                          aria-label={theme === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'}
                          title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
                          style={{ marginLeft: 0 }}
                        >
                          {theme === 'dark' ? '☀️' : '🌙'}
                        </button>

                        <div ref={mobileNotifMenuRef} style={{ position: 'relative', display: 'inline-block' }}>
                          <button
                            type="button"
                            aria-label="Notifications"
                            title="Notifications"
                            onClick={() => {
                              setNotifOpen(false);
                              setUserMenuOpen(false);
                              openDrawerPopup('notifications');
                            }}
                            style={{
                              height: 32,
                              width: 32,
                              borderRadius: 9999,
                              border: '1px solid rgba(0,0,0,0.08)',
                              background: 'transparent',
                              display: 'inline-flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              color: 'var(--text-color)',
                              cursor: 'pointer',
                              position: 'relative'
                            }}
                          >
                            <svg
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              aria-hidden="true"
                              focusable="false"
                            >
                              <path d="M12 3a6 6 0 00-6 6v3.382c0 .4-.158.784-.44 1.066L4.5 15.5h15l-1.06-2.052a1.5 1.5 0 01-.44-1.066V9a6 6 0 00-6-6z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M9.5 18a2.5 2.5 0 005 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                            </svg>
                            {unreadCount > 0 && (
                              <span
                                aria-label={`${unreadCount} notifications non lues`}
                                style={{
                                  position: 'absolute',
                                  top: -3,
                                  right: -3,
                                  minWidth: 16,
                                  height: 16,
                                  padding: '0 4px',
                                  borderRadius: 9999,
                                  background: 'var(--primary-color)',
                                  color: '#fff',
                                  fontSize: 10,
                                  lineHeight: '16px',
                                  textAlign: 'center',
                                  boxShadow: '0 0 0 2px var(--light-color)'
                                }}
                              >
                                {unreadCount}
                              </span>
                            )}
                          </button>
                        </div>

                        <div className="user-menu" ref={mobileUserMenuRef} style={{ marginLeft: 0 }}>
                          <button
                            type="button"
                            className="avatar-btn"
                            onClick={() => {
                              if (!currentUser) {
                                closeMobileMenu();
                                openAuthModal('login');
                                return;
                              }
                              setNotifOpen(false);
                              setUserMenuOpen(false);
                              openDrawerPopup('user');
                            }}
                            aria-haspopup="menu"
                            aria-expanded={userMenuOpen}
                            aria-label={currentUser ? 'Ouvrir le menu utilisateur' : 'Ouvrir le menu de connexion'}
                            style={{ height: 32, width: 32, marginLeft: 0 }}
                          >
                            {currentUser ? (
                              currentUser.avatarUrl ? (
                                <img src={currentUser.avatarUrl} alt="Avatar" className="avatar-img" />
                              ) : (
                                <span className="avatar-initial" style={{ fontSize: 14, fontWeight: 600 }}>
                                  {userInitial}
                                </span>
                              )
                            ) : (
                              <svg
                                width="18"
                                height="18"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                aria-hidden="true"
                                focusable="false"
                                style={{ display: 'block', color: 'inherit' }}
                              >
                                <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
                                <path d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                              </svg>
                            )}
                          </button>
                        </div>
                      </div>
                    </div>
                  </li>
                </>
              )}
              {/* homeLinkKey a été supprimé */}
              <li style={{ marginLeft: 0 }}><NavLink to="/" className={handleActiveStyle} end onClick={closeMobileMenu}>Accueil</NavLink></li>
              <li style={{ marginLeft: isDesktop ? 8 : 0 }}><NavLink to="/a-propos" className={handleActiveStyle} onClick={closeMobileMenu}>À Propos</NavLink></li>
              <li style={{ marginLeft: isDesktop ? 8 : 0 }}><NavLink to="/services" className={handleActiveStyle} onClick={closeMobileMenu}>Services</NavLink></li>
              <li style={{ marginLeft: isDesktop ? 8 : 0 }}><NavLink to="/realisations" className={handleActiveStyle} onClick={closeMobileMenu}>Réalisations</NavLink></li>
              <li style={{ marginLeft: isDesktop ? 8 : 0 }}><NavLink to="/tarifs" className={handleActiveStyle} onClick={closeMobileMenu}>Tarifs</NavLink></li>
              <li style={{ marginLeft: isDesktop ? 8 : 0 }}><NavLink to="/blog" className={handleActiveStyle} onClick={closeMobileMenu}>Blog</NavLink></li>
              <li style={{ marginLeft: isDesktop ? 8 : 0 }}><NavLink to="/contact" className={handleActiveStyle} onClick={closeMobileMenu}>Contact</NavLink></li>
              {currentUser ? (
                <li style={{ marginLeft: isDesktop ? 8 : 0, padding: isDesktop ? 0 : '0 1.5rem' }}>
                  <NavLink
                    to="/mon-compte"
                    className={(args) => `${handleActiveStyle(args)} btn-account`}
                    onClick={closeMobileMenu}
                    onMouseEnter={() => setHoveredAuth('account')}
                    onMouseLeave={() => setHoveredAuth(null)}
                    style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: 10,
                      width: isDesktop ? 'auto' : '100%',
                      boxSizing: 'border-box',
                      padding: isDesktop ? '8px 12px' : '12px 14px',
                      minHeight: 38,
                      borderRadius: isDesktop ? 10 : 12,
                      background: isDesktop ? 'var(--primary-color)' : 'linear-gradient(135deg, var(--primary-color) 0%, #1d4ed8 100%)',
                      color: '#fff',
                      boxShadow: isDesktop ? 'none' : '0 10px 20px rgba(0,0,0,0.18)',
                      filter: hoveredAuth === 'account' ? 'brightness(0.95)' : 'none',
                      textDecoration: 'none'
                    }}
                  >
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" style={{ display: 'block', flexShrink: 0 }}>
                      <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
                      <path d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                    </svg>
                    <span style={{ fontWeight: 800, letterSpacing: 0.2 }}>Mon compte</span>
                  </NavLink>
                </li>
              ) : (
                <>
                  <li style={{ marginLeft: isDesktop ? 8 : 0, padding: isDesktop ? 0 : '0 1.5rem' }}>
                    <NavLink
                      to={location.pathname}
                      className={(args) => `${handleActiveStyle(args)} btn-login`}
                      onClick={handleOpenLogin}
                      onMouseEnter={() => setHoveredAuth('login')}
                      onMouseLeave={() => setHoveredAuth(null)}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 10,
                        width: isDesktop ? 'auto' : '100%',
                        boxSizing: 'border-box',
                        padding: isDesktop ? '8px 12px' : '12px 14px',
                        minHeight: 38,
                        borderRadius: isDesktop ? 10 : 12,
                        border: isDesktop ? '1px solid var(--primary-color)' : '1px solid var(--primary-color)',
                        color: isDesktop ? 'var(--primary-color)' : 'var(--primary-color)',
                        background: isDesktop
                          ? (hoveredAuth === 'login' ? 'rgba(var(--primary-color-rgb, 0, 123, 255), 0.08)' : 'transparent')
                          : 'var(--light-color)',
                        boxShadow: isDesktop ? 'none' : '0 10px 20px rgba(0,0,0,0.10)',
                        textDecoration: 'none'
                      }}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" style={{ display: 'block', flexShrink: 0 }}>
                        <path d="M12 11a4 4 0 100-8 4 4 0 000 8z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M4 21c0-4 4-7 8-7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M15 12h7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M19 8l3 4-3 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span style={{ fontWeight: 800, letterSpacing: 0.2 }}>Se connecter</span>
                    </NavLink>
                  </li>
                  <li style={{ marginLeft: isDesktop ? 8 : 0, padding: isDesktop ? 0 : '10px 1.5rem 0' }}>
                    <NavLink
                      to="/inscription"
                      className={(args) => `${handleActiveStyle(args)} btn-signup`}
                      onClick={closeMobileMenu}
                      onMouseEnter={() => setHoveredAuth('signup')}
                      onMouseLeave={() => setHoveredAuth(null)}
                      style={{
                        display: 'inline-flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 10,
                        width: isDesktop ? 'auto' : '100%',
                        boxSizing: 'border-box',
                        padding: isDesktop ? '8px 12px' : '12px 14px',
                        minHeight: 38,
                        borderRadius: isDesktop ? 10 : 12,
                        background: isDesktop ? 'var(--primary-color)' : 'linear-gradient(135deg, var(--primary-color) 0%, #1d4ed8 100%)',
                        color: '#fff',
                        boxShadow: isDesktop ? 'none' : '0 10px 20px rgba(0,0,0,0.18)',
                        filter: hoveredAuth === 'signup' ? 'brightness(0.95)' : 'none',
                        textDecoration: 'none'
                      }}
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" style={{ display: 'block', flexShrink: 0 }}>
                        <path d="M12 11a4 4 0 100-8 4 4 0 000 8z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M4 21c0-4 4-7 8-7s8 3 8 7" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M19 8v6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                        <path d="M16 11h6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                      </svg>
                      <span style={{ fontWeight: 800, letterSpacing: 0.2 }}>S'inscrire</span>
                    </NavLink>
                  </li>
                </>
              )}
              {/* Switcher de langue dans le menu mobile - Supprimé */}
              {/* {isMenuOpen && (
                  <li className="language-switcher-mobile-item">
                      <LanguageSwitcher />
                  </li>
              )} */}
            </ul>
            {/* Switcher de langue pour la vue desktop - Supprimé */}
            {/* {!isMenuOpen && (
              <div className="language-switcher-desktop-container">
                  <LanguageSwitcher />
              </div>
            )} */}
            {/* Theme toggle (soleil) on the left */}
            <button
              type="button"
              className="theme-toggle-btn"
              onClick={toggleTheme}
              aria-label={theme === 'dark' ? 'Passer en mode clair' : 'Passer en mode sombre'}
              title={theme === 'dark' ? 'Mode clair' : 'Mode sombre'}
              style={{ marginLeft: isDesktop ? 24 : 12 }}
            >
              {theme === 'dark' ? '☀️' : '🌙'}
            </button>

            {/* Auth links are grouped inside the centered list above. */}

            {/* Notification icon next to avatar */}
            <div ref={notifMenuRef} style={{ position: 'relative', display: 'inline-block' }}>
              <button
                type="button"
                aria-label="Notifications"
                title="Notifications"
                onClick={() => {
                  if (!isDesktop) {
                    setNotifOpen(false);
                    setUserMenuOpen(false);
                    openDrawerPopup('notifications');
                    return;
                  }
                  toggleNotifications('desktop');
                }}
                style={{
                  marginLeft: 8,
                  height: 32,
                  width: 32,
                  borderRadius: 9999,
                  border: '1px solid rgba(0,0,0,0.08)',
                  background: 'transparent',
                  display: 'inline-flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  color: 'var(--text-color)',
                  cursor: 'pointer',
                  position: 'relative'
                }}
              >
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-hidden="true"
                  focusable="false"
                >
                  <path d="M12 3a6 6 0 00-6 6v3.382c0 .4-.158.784-.44 1.066L4.5 15.5h15l-1.06-2.052a1.5 1.5 0 01-.44-1.066V9a6 6 0 00-6-6z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
                  <path d="M9.5 18a2.5 2.5 0 005 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                </svg>
                {unreadCount > 0 && (
                  <span
                    aria-label={`${unreadCount} notifications non lues`}
                    style={{
                      position: 'absolute',
                      top: -3,
                      right: -3,
                      minWidth: 16,
                      height: 16,
                      padding: '0 4px',
                      borderRadius: 9999,
                      background: 'var(--primary-color)',
                      color: '#fff',
                      fontSize: 10,
                      lineHeight: '16px',
                      textAlign: 'center',
                      boxShadow: '0 0 0 2px var(--light-color)'
                    }}
                  >
                    {unreadCount}
                  </span>
                )}
              </button>
              {isDesktop && notifOpen && notifAnchor === 'desktop' && (
                <div
                  role="menu"
                  aria-label="Notifications"
                  style={{
                    position: 'absolute',
                    right: 0,
                    marginTop: 10,
                    minWidth: 280,
                    maxWidth: 320,
                    background: 'var(--light-color)',
                    color: 'var(--text-color)',
                    border: '1px solid var(--border-color-extra-light, #e7e7e7)',
                    borderRadius: 10,
                    boxShadow: '0 10px 30px rgba(0,0,0,0.12)',
                    padding: 8,
                    zIndex: 1100
                  }}
                >
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 6 }}>
                    <strong style={{ fontSize: 14 }}>Notifications</strong>
                    <button type="button" onClick={markAllRead} style={{ fontSize: 12, color: 'var(--primary-color)', background: 'transparent', border: 'none', cursor: 'pointer' }}>
                      Tout marquer comme lu
                    </button>
                  </div>
                  {notifications.length === 0 ? (
                    <div style={{ padding: '8px 6px', opacity: 0.8, fontSize: 13 }}>Aucune notification</div>
                  ) : (
                    <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                      {notifications.map(n => (
                        <li
                          key={n.id}
                          style={{
                            padding: '8px 6px',
                            borderRadius: 8,
                            background: n.read ? 'transparent' : 'rgba(0,0,0,0.03)',
                            cursor: n.type === 'action' ? 'pointer' : 'default',
                            transition: 'background-color 0.2s'
                          }}
                          onClick={() => {
                            // Marquer comme lue individuellement
                            setNotifications(prev => prev.map(notif => notif.id === n.id ? { ...notif, read: true } : notif));


                            if (n.type === 'action' && n.action && triggerOnboarding) {
                              triggerOnboarding(n.action);
                              setNotifOpen(false); // Fermer le menu notif
                            } else if (n.type === 'link' && n.link) {
                              navigate(n.link);
                              setNotifOpen(false);
                            }
                          }}
                          onMouseEnter={(e) => {
                            if (n.type === 'action') e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.06)';
                          }}
                          onMouseLeave={(e) => {
                            if (n.type === 'action') e.currentTarget.style.backgroundColor = n.read ? 'transparent' : 'rgba(0,0,0,0.03)';
                          }}
                        >
                          <div style={{ fontSize: 13, fontWeight: 600 }}>{n.title}</div>
                          {n.time && <div style={{ fontSize: 12, opacity: 0.7 }}>{n.time}</div>}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              )}
            </div>

            {/* Avatar (bonhomme) on the far right */}
            <div className="user-menu" ref={userMenuRef}>
              <button
                type="button"
                className="avatar-btn"
                onClick={() => {
                  if (!isDesktop) {
                    if (!currentUser) {
                      closeMobileMenu();
                      openAuthModal('login');
                      return;
                    }
                    setNotifOpen(false);
                    setUserMenuOpen(false);
                    openDrawerPopup('user');
                    return;
                  }
                  toggleUserMenu('desktop');
                }}
                aria-haspopup="menu"
                aria-expanded={userMenuOpen}
                aria-label={currentUser ? 'Ouvrir le menu utilisateur' : 'Ouvrir le menu de connexion'}
                style={{ height: 32, width: 32 }}
              >
                {currentUser ? (
                  currentUser.avatarUrl ? (
                    <img src={currentUser.avatarUrl} alt="Avatar" className="avatar-img" />
                  ) : (
                    <span className="avatar-initial" style={{ fontSize: 14, fontWeight: 600 }}>
                      {userInitial}
                    </span>
                  )
                ) : (
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    aria-hidden="true"
                    focusable="false"
                    style={{ display: 'block', color: 'inherit' }}
                  >
                    <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
                    <path d="M4 20c0-3.314 3.582-6 8-6s8 2.686 8 6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
                  </svg>
                )}
              </button>
              {isDesktop && currentUser && userMenuOpen && userMenuAnchor === 'desktop' && (
                <div className="user-dropdown" role="menu">
                  <ul>
                    <li className="user-id-line">{currentUser.name || currentUser.email}</li>
                    {isAdmin && (
                      <li>
                        <NavLink to="/admin" onClick={() => setUserMenuOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          Espace admin
                        </NavLink>
                      </li>
                    )}
                    {isCommercial && (
                      <li>
                        <NavLink to="/commercial/launchpad" onClick={() => setUserMenuOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                          Espace commercial
                        </NavLink>
                      </li>
                    )}
                    <li>
                      <NavLink to="/mon-compte" onClick={() => setUserMenuOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        Mon profil
                      </NavLink>
                    </li>
                    <li>
                      <NavLink to="/mon-compte" onClick={() => setUserMenuOpen(false)} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        Espace client
                      </NavLink>
                    </li>
                    <li>
                      <button type="button" className="logout-btn" onClick={() => { logout(); setUserMenuOpen(false); }} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 17l5-5-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        Se déconnecter
                      </button>
                    </li>
                  </ul>
                </div>
              )}
            </div>

          </div>

          <button
            className={`mobile-menu-toggle ${isMenuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label={isMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={isMenuOpen}
          >
            <span className="burger-line"></span>
            <span className="burger-line"></span>
            <span className="burger-line"></span>
          </button>

        </div>
        {isMenuOpen && <div className="mobile-menu-backdrop" onClick={closeMobileMenu}></div>}
      </nav>

      {!isDesktop && drawerPopupOpen && (
        <>
          <div className="drawer-popup-backdrop" onClick={closeDrawerPopup} />
          <div className="drawer-popup" role="dialog" aria-modal="true">
            <button type="button" className="drawer-popup-close" onClick={closeDrawerPopup} aria-label="Fermer">
              ✕
            </button>
            {drawerPopupType === 'notifications' ? (
              <>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 10, paddingRight: 46 }}>
                  <strong style={{ fontSize: 15 }}>Notifications</strong>
                  <button type="button" onClick={markAllRead} style={{ fontSize: 12, color: 'var(--primary-color)', background: 'transparent', border: 'none', cursor: 'pointer' }}>
                    Tout marquer comme lu
                  </button>
                </div>
                {notifications.length === 0 ? (
                  <div style={{ padding: '8px 6px', opacity: 0.8, fontSize: 13 }}>Aucune notification</div>
                ) : (
                  <ul style={{ listStyle: 'none', margin: 0, padding: 0 }}>
                    {notifications.map(n => (
                      <li
                        key={n.id}
                        style={{
                          padding: '8px 6px',
                          borderRadius: 8,
                          background: n.read ? 'transparent' : 'rgba(0,0,0,0.03)',
                          cursor: n.type === 'action' ? 'pointer' : 'default'
                        }}
                        onClick={() => {
                          // Marquer comme lue individuellement
                          setNotifications(prev => prev.map(notif => notif.id === n.id ? { ...notif, read: true } : notif));

                          if (n.type === 'action' && n.action && triggerOnboarding) {
                            closeDrawerPopup();
                            triggerOnboarding(n.action);
                          } else if (n.type === 'link' && n.link) {
                            closeDrawerPopup();
                            navigate(n.link);
                          }
                        }}
                      >
                        <div style={{ fontSize: 13, fontWeight: 600 }}>{n.title}</div>
                        {n.time && <div style={{ fontSize: 12, opacity: 0.7 }}>{n.time}</div>}
                      </li>
                    ))}
                  </ul>
                )}
              </>
            ) : (
              <div className="user-dropdown" role="menu" style={{ position: 'static', marginTop: 0, boxShadow: 'none', border: 'none', padding: 0 }}>
                <ul>
                  <li className="user-id-line">{currentUser?.name || currentUser?.email}</li>
                  {isAdmin && (
                    <li>
                      <NavLink to="/admin" onClick={() => { closeDrawerPopup(); closeMobileMenu(); }} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        Espace admin
                      </NavLink>
                    </li>
                  )}
                  {isCommercial && (
                    <li>
                      <NavLink to="/commercial/launchpad" onClick={() => { closeDrawerPopup(); closeMobileMenu(); }} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 10V3L4 14h7v7l9-11h-7z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                        Espace commercial
                      </NavLink>
                    </li>
                  )}
                  <li>
                    <NavLink to="/mon-compte" onClick={() => { closeDrawerPopup(); closeMobileMenu(); }} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><circle cx="12" cy="7" r="4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      Mon profil
                    </NavLink>
                  </li>
                  <li>
                    <NavLink to="/mon-compte" onClick={() => { closeDrawerPopup(); closeMobileMenu(); }} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="2" y="7" width="20" height="14" rx="2" ry="2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 21V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      Espace client
                    </NavLink>
                  </li>
                  <li>
                    <button type="button" className="logout-btn" onClick={() => { logout(); closeDrawerPopup(); closeMobileMenu(); }} style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M16 17l5-5-5-5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /><path d="M21 12H9" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
                      Se déconnecter
                    </button>
                  </li>
                </ul>
              </div>
            )}
          </div>
        </>
      )}

      {/* AuthModal supprimé de Navbar, géré par le parent */}
    </>
  );
}

export default Navbar;
